import React from "react";
import { ResponsiveBar } from "@nivo/bar";
import Colors from "../../constants/Colors";

const dataTest = [
  {
    id: 1,
    date: "Janvier - 1",
    actions: 12,
    actionsColor: "hsl(84, 70%, 50%)"
  },
  {
    id: 2,
    date: "Janvier - 2",
    actions: 25,
    actionsColor: "hsl(84, 70%, 50%)"
  },
  {
    date: "Janvier - 3",
    actions: 47,
    actionsColor: "hsl(84, 70%, 50%)"
  },
  {
    date: "Janvier - 4",
    actions: 53,
    actionsColor: "hsl(84, 70%, 50%)"
  },
  {
    date: "Février - 1",
    actions: 82,
    actionsColor: "hsl(84, 70%, 50%)"
  },
  {
    date: "Février - 2",
    actions: 94,
    actionsColor: "hsl(84, 70%, 50%)"
  }
];
const colorRange = [
  "rgba(252,87,122,0.8)",
  "rgba(66,80,251,0.8)",
  "rgba(0,170,255,0.8)",
  "#FF9F40",
  "#FFC233"
];

const EvolutionChart = ({ data }) => {
  return (
    <ResponsiveBar
      data={data}
      keys={["actions"]}
      indexBy="date"
      margin={{
        top: 20,
        right: 10,
        bottom: 20,
        // left: 60
        left: 10
      }}
      padding={0.8}
      groupMode="grouped"
      //   colors="nivo"
      colors={[
        "rgba(252,87,122,0.8)",
        "rgba(66,80,251,0.8)",
        "rgba(0,170,255,0.8)"
      ]}
      colorBy={data => {
        let range = 0;
        if (data.index <= 1) {
        } else if (data.index <= 3) {
          range = 1;
        } else if (data.index <= 5) {
          range = 2;
        } else if (data.index <= 7) {
          range = 3;
        }
        return colorRange[range];
      }}
      borderRadius={10}
      borderColor="inherit:darker(1.6)"
      axisBottom={{
        orient: "bottom",
        tickSize: 0,
        tickPadding: 5,
        tickRotation: 0,
        // legend: "semaines",
        legend: "",
        legendPosition: "middle",
        legendOffset: 36
      }}
      axisLeft={{
        tickValues: [],
        orient: "left",
        color: "#fff",
        tickSize: 0,
        tickPadding: 5,
        tickRotation: 0,
        // legend: "actions",
        legend: "",
        legendPosition: "middle"
        // legendOffset: -40
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      animate={true}
      motionStiffness={90}
      motionDamping={15}
      enableGridY={false}
      enableLabel={false}
      //   labelTextColor="#fff"
      //   labelTextColor="inherit:darker(1.6)"
      legends={[]}
      theme={{
        axis: {
          ticks: {
            line: {
              //   stroke: "E8F3FD"
            },
            text: {
              fill: "#3A4554"
            }
          }
        },
        grid: {
          line: {
            stroke: "#E8F3FD",
            strokeWidth: 0
          },
          label: {
            color: "#fff"
          }
        }
      }}
    />
  );
};

EvolutionChart.defaultProps = {
  data: [
    {
      id: 1,
      date: "Janvier - 1",
      actions: 0,
      actionsColor: "hsl(84, 70%, 50%)"
    },
    {
      id: 2,
      date: "Janvier - 2",
      actions: 0,
      actionsColor: "hsl(84, 70%, 50%)"
    },
    {
      date: "Janvier - 3",
      actions: 0,
      actionsColor: "hsl(84, 70%, 50%)"
    },
    {
      date: "Janvier - 4",
      actions: 0,
      actionsColor: "hsl(84, 70%, 50%)"
    },
    {
      date: "Février - 1",
      actions: 0,
      actionsColor: "hsl(84, 70%, 50%)"
    },
    {
      date: "Février - 2",
      actions: 0,
      actionsColor: "hsl(84, 70%, 50%)"
    }
  ]
};

export default EvolutionChart;
